import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { StaffUserService } from "./StaffUserService";

interface StaffUserServiceProviderProps {
  children: React.ReactNode;
}

export const StaffUserServiceContext = React.createContext<
  StaffUserService | undefined
>(undefined);

export const StaffUserServiceProvider: React.FC<
  StaffUserServiceProviderProps
> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new StaffUserService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <StaffUserServiceContext.Provider value={service}>
      {children}
    </StaffUserServiceContext.Provider>
  );
};

export const useStaffUserService = (): StaffUserService => {
  const context = React.useContext(StaffUserServiceContext);
  if (context === undefined) {
    throw new Error(
      "useStaffUserService must be used within a StaffUserServiceProvider"
    );
  }
  return context;
};
